<template>
  <div class="app-main-content">
    <div class="tabs-container" style="position: relative">
      <el-tabs v-model="activeTabName" type="card" style="width:100%">
        <el-tab-pane label="AMS" name="ams" :lazy="true">
          <ams-info-ai
            v-if="amsIsLink"
            ref="ams"
            :context="context"
            :action="action"
            :tab-name="activeTabName"
            :ams2="ams2"
            :form="form"
            :container="container"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
          />
          <ams-info
            v-else
            ref="ams"
            :context="context"
            :action="action"
            :show-code-search="true"
            :tab-name="activeTabName"
            :ams2="ams2"
            :is-js="isJs"
            :form="form"
            :container="container"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
          />
        </el-tab-pane>
        <el-tab-pane label="ISF" name="isf" :lazy="true">
          <ams-info
            ref="isf"
            :context="context"
            :action="action"
            :show-i-s-f="true"
            :tab-name="activeTabName"
            :ams2="ams2"
            :form="form"
            :container="container"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
            :party-name-list="partyNameList"
          />
        </el-tab-pane>
        <el-tab-pane label="ACI" name="aci" :lazy="true">
          <ams-info
            ref="aci"
            :context="context"
            :action="action"
            :show-code-search="true"
            :tab-name="activeTabName"
            :ams2="ams2"
            :form="form"
            :container="container"
            :pm="pm"
            :party-name-list="partyNameList"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
            :is-js="isJs"
          />
        </el-tab-pane>
        <el-tab-pane label="eManifest" name="eManifest" :lazy="true">
          <ams-info
            ref="eManifest"
            :context="context"
            :action="action"
            :show-code-search="true"
            :show-second-notify-party="true"
            :tab-name="activeTabName"
            :ams2="ams2"
            :form="form"
            :container="container"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
          />
        </el-tab-pane>
        <el-tab-pane label="AFR" name="afr" :lazy="true">
          <afr-info-ai
            v-if="afrIsLink"
            ref="afr"
            :context="context"
            :action="action"
            :tab-name="activeTabName"
            :afr2="afr2"
            :form="afrForm"
            :container="afrContainer"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
          />
          <afr-info
            v-else
            ref="afr"
            :context="context"
            :action="action"
            :show-code-search="true"
            :tab-name="activeTabName"
            :afr2="afr2"
            :master-info="masterInfo"
            :form="afrForm"
            :container="afrContainer"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
            :is-js="isJs"
          />
        </el-tab-pane>
        <el-tab-pane v-if="showThailandFlag" label="Thailand" name="thailand" :lazy="true">
          <thailand-info
            :action="action"
            :thailand2="thailand2"
            :form="thailandForm"
            :container="thailandContainer"
            :job="job"
            :txt-carrier-sc-ac="localData.carrierScAc"
            :cooperate-edit="cooperateEdit"
            @syncThailandInfo="field=>{pm.syncThailandInfo(field)}"
            @synchroThailandClickHandler="pm.btnSynchroThailandClickHandler()"
            @removeCargoDoc="pm.onRemoveThailandCargoDoc()"
          />
        </el-tab-pane>
        <el-tab-pane v-if="!isNewWindowByENS" label="ENS" name="ens" :lazy="true">
          <ens-info
            ref="ens"
            :context="context"
            :action="action"
            :show-code-search="true"
            :tab-name="activeTabName"
            :ams2="ams2"
            :form="form"
            :container="container"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
          />
        </el-tab-pane>
        <el-tab-pane v-if="isNewWindowByENS" label="ENS" name="ens" :lazy="true">
          <ens-info-ai
            ref="ens"
            :context="context"
            :action="action"
            :show-code-search="true"
            :tab-name="activeTabName"
            :ams2="ams2"
            :form="form"
            :container="container"
            :pm="pm"
            :local-data="localData"
            :cooperate-edit="cooperateEdit"
          />
        </el-tab-pane>
      </el-tabs>
      <div v-show="cooperateEdit" :style="{position: 'absolute', left: !job.lclMasterUuid ? '430px' : '380px'}">
        <template v-if="activeTabName === 'thailand'">
          <el-button :disabled="thailandEdit" type="primary" style="margin-left: 108px" no="1" @click="sendInThailand">{{ getItemTitle('Send') }}</el-button>
        </template>
        <template v-else-if="(tabEns && isNewWindowByENS) || (tabAms && amsIsLink) || (tabAfr && afrIsLink)">
          <el-dropdown
            :title="$t('SeaExport.send')"
            :disabled="!readonly"
            style="padding-left: 110px"
            split-button
            type="primary"
            :class="readonly?'':'not-click'"
            no="3"
            @command="p=>pm.send(p.type, p.index)"
          >
            {{ this.getItemTitle('Send') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item) in sendTypes" :key="item.label" :disabled="!item.enabled" :command="item">{{ item.label }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
        <template v-else>
          <el-checkbox
            v-if="activeTabName !== 'afr'"
            v-model="amsCheck"
            :disabled="activeTabName === 'afr'"
            :title="$t('SeaExport.DoNotImportAndSend')"
            style="margin-left: 10px; margin-right: 10px;"
            no="2"
          >{{ getItemTitle('Import only') }}</el-checkbox>
          <el-dropdown
            :title="$t('SeaExport.send')"
            :disabled="!readonly"
            style="padding-left: 10px;padding-right: 5px"
            split-button
            type="primary"
            :class="readonly?'':'not-click'"
            no="3"
            @command="p=>pm.send(p.type, p.index)"
          >
            {{ this.getItemTitle('Send') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for="(item) in sendTypes" :key="item.label" :disabled="!item.enabled" :command="item">{{ item.label }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-if="!isJs"
            type="primary"
            :title="$t('SeaExport.CheckStatus')"
            no="4"
            @click="pm.queryAMS()"
          >{{ getItemTitle('Query Status') }}</el-button>
          <el-button
            :title="$t('SeaExport.ViewReceipt')"
            type="primary"
            no="5"
            @click="pm.queryAMSReceiptInfoClickHandler()"
          >{{ getItemTitle('Receipt') }}</el-button>
          <el-button
            v-if="isJs && tabAms"
            :disabled="jsError"
            :title="$t('SeaExport.Error')"
            type="primary"
            no="4"
            @click="pm.queryJsAmsErrorMessage()"
          >{{ getItemTitle('Error') }}</el-button>
          <el-button
            v-show="showExcel"
            :title="$t('SeaExport.DownloadTemplate')"
            type="primary"
            no="6"
            @click="onDownloadTemplateRelease()"
          >{{ getItemTitle('Template Download') }}</el-button>
          <el-button
            v-show="tabEManifest && !isJs"
            :title="$t('SeaExport.DownloadTemplate')"
            type="primary"
            no="6"
            @click="onDownloadTemplateRelease()"
          >{{ getItemTitle('Template Download') }}</el-button>
          <el-dropdown
            v-show="tabIsf && !isJs"
            style="margin-left: 5px;"
            split-button
            type="primary"
            no="1"
            @click="commandHandle(command)"
            @command="p=>{command=p;commandHandle(command);}"
          >
            {{ getItemTitle('Template Download') }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="ISF5">{{ $t('Message.ISF5File') }}</el-dropdown-item>
              <el-dropdown-item command="ISF10">{{ $t('Message.ISF10File') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-upload
            v-show="showExcel && !tabAfr && !isJs && !tabEns"
            :disabled="readonly"
            action="string"
            :http-request="importAMSExcel"
            :show-file-list="false"
            accept=".xls, .xlsx"
            style="display: inline-block; margin-left: 5px;"
            :before-upload="beforeUpload"
          >
            <el-button
              slot="trigger"
              :disabled="readonly"
              :title="$t('SeaExport.ImportEXCEL')"
              type="primary"
              no="7"
            >{{ getItemTitle('Import Template') }}</el-button>
          </el-upload>
          <el-upload
            v-show="showExcel && tabAfr && !isJs"
            :disabled="readonly"
            action="string"
            :http-request="importAFRExcel"
            :show-file-list="false"
            accept=".xls, .xlsx"
            style="display: inline-block; margin-left: 5px;"
            :before-upload="beforeUpload"
          >
            <el-button
              slot="trigger"
              :disabled="readonly"
              :title="$t('SeaExport.ImportEXCEL')"
              type="primary"
              no="8"
            >{{ getItemTitle('Import Template') }}</el-button>
          </el-upload>
          <el-upload
            v-show="tabEns"
            :disabled="readonly"
            action="string"
            :http-request="importEnsExcel"
            :show-file-list="false"
            accept=".xls, .xlsx"
            style="display: inline-block; margin-left: 5px;"
            :before-upload="beforeUpload"
            no="uploadJs"
          >
            <el-button
              slot="trigger"
              :disabled="readonly"
              :title="$t('SeaExport.ImportEXCEL')"
              type="primary"
              no="importExcelJs"
            >{{ getItemTitle('Import Template') }}</el-button>
          </el-upload>
          <el-upload
            v-show="showExcel && isJs && (tabAms || tabAfr || tabAci)"
            :disabled="readonly"
            action="string"
            :http-request="importJsExcel"
            :show-file-list="false"
            accept=".xls, .xlsx"
            style="display: inline-block; margin-left: 5px;"
            :before-upload="beforeUpload"
            no="uploadJs"
          >
            <el-button
              slot="trigger"
              :disabled="readonly"
              :title="$t('SeaExport.ImportEXCEL')"
              type="primary"
              no="importExcelJs"
            >{{ getItemTitle('Import Template') }}</el-button>
          </el-upload>
          <el-upload
            v-show="tabIsf && !isJs"
            :disabled="readonly"
            action="string"
            :http-request="importIsfExcel"
            :show-file-list="false"
            accept=".xls, .xlsx"
            style="display: inline-block; margin-left: 5px;"
            :before-upload="beforeUpload"
          >
            <el-button
              slot="trigger"
              :disabled="readonly"
              :title="$t('SeaExport.ImportEXCEL')"
              type="primary"
            >{{ getItemTitle('Import Template') }}</el-button>
          </el-upload>
          <el-upload
            v-show="tabEManifest && !isJs"
            :disabled="readonly"
            action="string"
            :http-request="importEManifestExcel"
            :show-file-list="false"
            accept=".xls, .xlsx"
            style="display: inline-block; margin-left: 5px;"
            :before-upload="beforeUpload"
          >
            <el-button
              slot="trigger"
              :disabled="readonly"
              :title="$t('SeaExport.ImportEXCEL')"
              type="primary"
            >{{ getItemTitle('Import Template') }}</el-button>
          </el-upload>
          <el-button
            v-show="!tabAfr && !(isJs && (tabAms || tabAci))"
            style="margin-left: 5px"
            type="primary"
            no="9"
            @click="jumpToCargo"
          >{{ $t('CargoMsg.Cargo_SwitchToTheOldVersion') }}</el-button>
        </template>
      </div>
    </div>
    <!-- 回执信息弹框 -->
    <el-dialog
      v-if="receiptInfoDialog.visible"
      v-el-drag-dialog
      no="receiptInfoDialog"
      :visible.sync="receiptInfoDialog.visible"
      :title="receiptInfoDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        no="receiptInfoDialog"
        :v-if="!(isTradetech&&deleteAMS)"
        :grid-options="receiptInfoDialog.gridOptions"
        :column-defs="receiptColumnDefs"
        :row-data="receiptInfoDialog.rowData"
        style="height:350px"
        @gridReady="params=>{receiptInfoDialog.gridApi=params.api}"
      />
      <span slot="footer">
        <el-button
          no="11"
          @click="receiptInfoDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 回执信息弹框 -->
    <el-dialog
      v-if="tradetechReceiptInfoDialog.visible"
      v-el-drag-dialog
      no="tradetechReceiptInfoDialog"
      :visible.sync="tradetechReceiptInfoDialog.visible"
      :title="tradetechReceiptInfoDialog.title"
      config-module="20240304"
      width="1000px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-ag-grid
        no="tradetechReceiptInfoDialog"
        :v-if="isTradetech&&deleteAMS"
        :grid-options="tradetechReceiptInfoDialog.gridOptions"
        :column-defs="tradetechReceiptColumnDefs"
        :row-data="tradetechReceiptInfoDialog.rowData"
        style="height:350px"
        @gridReady="params=>{tradetechReceiptInfoDialog.gridApi=params.api}"
      />
      <cargo-pagination
        config-module="990004"
        :total="tradetechReceiptInfoDialog.filter.total"
        :page-count="tradetechReceiptInfoDialog.filter.pageCount"
        :page.sync="tradetechReceiptInfoDialog.filter.pageNum"
        :limit.sync="tradetechReceiptInfoDialog.filter.pageSize"
        @pagination="toTradetechQueryByPage"
      />
      <span slot="footer">
        <el-button
          no="11"
          @click="tradetechReceiptInfoDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="afrXmlDialog.visible"
      title="Preview Message"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <cargo-rich-textarea
        ref="afrContent"
        v-model="afrXmlDialog.content"
        no="afrContent"
        :text-chars="0"
        :warning-count="-1"
        style="height: 560px"
      />
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="success" no="12" @click="pm.sendAfrEFreightXml()">{{ 'Send' }}</el-button>
        <el-button type="primary" no="13" @click="pm.downloadTxtFile()">Export Current Page</el-button>
        <el-button no="14" @click="afrXmlDialog.visible = false">{{ 'Close' }}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="amsXmlDialog.visible"
      title="Preview Message"
      width="600px"
      :close-on-click-modal="false"
      append-to-body
    >
      <cargo-rich-textarea
        ref="amsContent"
        v-model="amsXmlDialog.content"
        no="amsContent"
        :text-chars="0"
        :warning-count="-1"
        style="height: 560px"
      />
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button v-if="tabEns" type="success" no="15" @click="pm.sendENSxml(ensIndex)">{{ 'Send' }}</el-button>
        <el-button v-else type="success" no="15" @click="(currentType==='ISF10'||currentType==='ISF05')?pm.sendISFXml(currentIndex,currentType):pm.sendAmsXml()">{{ 'Send' }}</el-button>
        <el-button type="primary" no="16" @click="pm.downloadAMSTxtFile()">Export Current Page</el-button>
        <el-button no="17" @click="amsXmlDialog.visible = false">{{ 'Close' }}</el-button>
      </div>
    </el-dialog>
    <!-- 泰国舱单导出弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="thailandExportDialog.visible"
      :title="thailandExportDialog.showReminder ? 'Reminder' : 'Preview Message'"
      width="600px"
      class="thailand-export"
      :close-on-click-modal="false"
      append-to-body
    >
      <div v-if="thailandExportDialog.showReminder" style="display: flex;">
        <div style="display: flex;align-items: center;">
          <i class="el-icon-warning" style="color: #E6A23C;font-size: 20px;" />
        </div>
        <div style="flex-grow: 1;">
          <div style="padding-left: 5px;line-height: 20px;">These fields may have issues</div>
          <cargo-rich-textarea
            v-model="thailandExportDialog.reminderContent"
            :text-chars="0"
            :warning-count="-1"
            style="height: 480px"
            no="18"
          />
        </div>
      </div>
      <cargo-rich-textarea
        v-if="!thailandExportDialog.showReminder"
        v-model="thailandExportDialog.content"
        :text-chars="0"
        :warning-count="-1"
        style="height: 500px"
        no="19"
      />
      <span v-if="thailandExportDialog.showReminder" slot="footer">
        <el-button type="primary" no="20" @click="thailandExportDialog.showReminder = false">Continue</el-button>
      </span>
      <div v-if="!thailandExportDialog.showReminder" slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" no="21" @click="doExportThailand">Export Current Page</el-button>
        <el-button no="22" @click="thailandExportDialog.visible = false">{{ 'Close' }}</el-button>
      </div>
    </el-dialog>

    <!-- 劲升AFR删除确认弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="jsAfrDeleteDialog.visible"
      :title="jsAfrDeleteDialog.title"
      :before-close="jsAfrDeleteClose"
      width="450px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <br><br>
      <p style="text-align: center; font-weight: bold;">Are you sure you want to delete? Please select the reason for deletlon.</p>
      <br>
      <el-form>
        <el-form-item label="DeletionReason" label-width="120px">
          <cargo-advance-select
            options-width="205px;"
            no="57"
            :static-options="SystemConstants.JS_AFR_DELETE"
            :cache="false"
            :clearable="false"
            :default-value="jsAfrDeleteDialog.deletionCode"
            tag-name="chineseName"
            tag-value="code"
            @parentCallBack="p=>{jsAfrDeleteDialog.deletionCode = p.value;jsAfrDeleteDialog.deletionReason = p.chineseName;}"
          />
        </el-form-item>
      </el-form>
      <br><br>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="pm.confirmDeletion()">Confirm</el-button>
        <el-button @click="jsAfrDeleteClose">Cancel</el-button>
      </span>
    </el-dialog>

    <!-- 删除原因弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="deleteReasonDialog.visible"
      :title="$t('Message.ReasonForDeletion')"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form ref="deleteReasonForm" :model="deleteReasonDialog" :rules="deleteReasonRules" label-width="120px">
        <br>
        <el-form-item prop="reasonCode" required>
          <span slot="label">{{ $t('Message.ReasonForDeletion') }}：</span>
          <el-select
            v-model="deleteReasonDialog.reasonCode"
            :placeholder="$t('SeaExport.WseDeleteReasonNotEmpty')"
            style="width: 100%"
            @change="onDeleteReasonChange"
          >
            <el-option
              v-for="item in deleteReasonOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <br>
        <br>
        <el-form-item :label="$t('SeaExport.Instructions')+'：'" prop="reasonDescription" label-width="120px">
          <el-input
            v-model="deleteReasonDialog.reasonDescription"
            type="textarea"
            :rows="4"
            :placeholder="$t('SeaExport.ExplanationRequired')"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirmDeleteReason">{{ $t('SeaExport.ConfirmDeletion') }}</el-button>
        <el-button @click="cancelDeleteReason">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>

    <dialog-selector
      :visible.sync="selectorDialog.visible"
      :title="selectorDialog.title"
      :row-data="selectorDialog.rowData"
      @selected="selectorDialogCallback"
    />
    <!-- EDI报文结果预览页弹窗组件 -->
    <message-preview-dialog
      :visible.sync="messagePreviewDialog.visible"
      :params="messagePreviewDialog.params"
      @uploadSuccess="messagePreviewDialog.visible = false"
    />
    <!--ens状态回执弹窗-->
    <ens-receipt-details-dialog
      :pm="pm"
      :visible.sync="ensDataStatusDialog.visible"
      :job-no="ensDataStatusDialog.jobNo"
      :hbl-nbr2="ensDataStatusDialog.hblNbr2"
      :is-chinese-language="ensDataStatusDialog.isZh"
      :type="ensDataStatusDialog.type"
      :tab-name="activeTabName"
    />
  </div>
</template>

<script>
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import DialogSelector from '@/views/cargo/v0/SeaExport/components/edi/dialogSelector'
import messagePreviewDialog from '@/views/cargo/v0/SeaExport/components/edi/messagePreviewDialog'
import { TabAMSPM } from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabAMSPM'
import {
  importAciExcel,
  importAfrExcel,
  importAmsExcel,
  importEManifestExcel, importEnsExcel, importIsf10Excel, importIsf5Excel
} from '@/api/seaExport/seaCargoDoc'
import CargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import { SeaCargoDoc } from '@/class/model/booking/SeaCargoDoc'
import { ensureExecuteSuccess, roundHalfUp } from '@/utils/commonUtil'
import * as AmsBLType from '@/class/cargo/model/parameters/AmsBLType'
import * as ShipmentTypeCode from '@/class/cargo/model/parameters/ShipmentTypeCode'
import * as isfPassengerApi from '@/api/seaExport/isfPassenger'
import AmsInfo from '@/views/cargo/v0/SeaExport/components/booking/ams/amsInfo'
import EnsInfo from '@/views/cargo/v0/SeaExport/components/booking/ams/ensInfo'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { loadSpecificBasicInfo } from '@/api/cache'
import { ExportUtils } from '@/class/cargo/model/utils/ExportUtils'
import StrUtils from '@/utils/StrUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import LocalStorageUtils from '@/utils/localStorageUtils'
import { getObjectByCache, getSpecificBasicData } from '@/utils/basicDataCache'
import store from '@/store'
import { cache, cacheName } from '@/utils/cacheManager'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceTextEditor from '@/components/Cargo/Common/CargoAgGridAdvanceTextEditor/index'
import AfrInfo from '@/views/cargo/v0/SeaExport/components/booking/ams/afrInfo.vue'
import ThailandInfo from '@/views/cargo/v0/SeaExport/components/booking/ams/thailandInfo.vue'
import { TabError } from '@/utils/class/TabError'
import sendThailand from '@/views/cargo/v0/SeaExport/components/booking/ams/sendThailand.js'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import { getUserOfficeList } from '@/api/user'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import * as ediApi from '@/api/seaExport/edi'
import { SAVE } from '@/class/cargo/model/parameters/AmsType'
import * as EdiType from '@/class/cargo/model/parameters/EdiType'
import EnsInfoAi from '@/views/cargo/v0/SeaExport/components/booking/ams/ensInfoAi.vue'
import AmsInfoAi from '@/views/cargo/v0/SeaExport/components/booking/ams/amsInfoAi.vue'
import AfrInfoAi from '@/views/cargo/v0/SeaExport/components/booking/ams/afrInfoAi.vue'
import ensReceiptDetailsDialog from '@/views/cargo/v0/SeaExport/components/booking/ams/ensReceiptDetailsDialog.vue'
import CargoAgGridColumnEditGroup from '@/components/Cargo/Common/CargoAgGridColumnEditGroup.vue'

export default {
  name: 'TabAms',
  components: {
    EnsInfoAi,
    AmsInfoAi,
    AfrInfoAi,
    AfrInfo,
    ThailandInfo,
    AmsInfo,
    EnsInfo,
    CargoRichTextarea,
    CargoAdvanceSelect,
    DialogSelector,
    messagePreviewDialog,
    ensReceiptDetailsDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      SystemConstants,
      activeTabName: 'ams',
      amsInterfaceName: '',
      deleteAMS: false,
      isTradetech: false,
      job: {},
      command: '',
      form: new SeaCargoDoc().fillDefaultValue().getData(),
      afrForm: new SeaCargoDoc().fillDefaultValue().getData(),
      thailandForm: new SeaCargoDoc().fillDefaultValue().getData(),
      pm: new TabAMSPM(this),
      amsCheck: true,
      curAms: null,
      curAfr: null,
      initJobUuid: '',
      oldAmsNo: '',
      partyNameList: [],
      activeIsfTabName: 'tabBookingISF10',
      cargoDocs: [],
      afrCargoDocs: [],
      thailandCargoDocs: [],
      localData: {
        voyages: [],
        vesselList: [],
        eFreighs: [], // 加拿大申报账户
        emainAccountStr: '',
        emainAccountAciStr: '',
        eFreighsAciList: [], // 加拿大申报账户
        eFreighsAmsList: [], // 加拿大申报账户
        nvoccScacList: [], // 无船承运人SCAC列表
        jsCountry: [], // 劲升国家代码
        jsPortList: [], // 劲生 AMS、ACI 港口
        jsAmsDischargingList: [], // 劲生 AMS 卸货港
        jsAfrPortList: [], // 劲生 AFR 港口
        jsAfrPacking: [], // 劲升 AFR 包装代码
        jsAfrDangerous: [], // 劲升 AFR 危险品代码
        ytCountry: [], // 亿通 进入欧盟的第一个国家代码
        carrierEoriList: [], // 船公司Eori列表
        shipCompanyInfos: [], // 平台维护船公司数据
        linkAfrSpcCode: [], // link afr SPC Code
        dishSubLocStr: '',
        subLocationCodeStr: '',
        carrierScAc: '',
        txtCarrierScAc: '',
        afrCarrierScAc: '',
        eManifestCarrierScAc: '',
        nameOfCountry: '',
        importDifferentField: {}
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        showContact: false,
        extendData: {
          contact: '',
          mobile: '',
          fax: '',
          email: '',
          zipCode: '',
          city: ''
        },
        successCallback: null,
        isUppercase: false,
        formatObj: {
          maxChar: 45
        }
      },
      ams2: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
            // this.ams2.isSelected = false
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => {
            this.curAms = event.data
            this.pm.onSelectionChange(event.data)
          },
          // ens时双击数据
          onCellDoubleClicked: event => {
            if (this.readonly && event.data && this.tabEns && this.isNewWindowByENS) {
              this.ensDataStatusDialog.visible = true
              this.ensDataStatusDialog.jobNo = this.job.jobNo
              this.ensDataStatusDialog.hblNbr2 = this.form.hblNbr2
              this.ensDataStatusDialog.isZh = this.$store.getters.language === 'zh'
              this.ensDataStatusDialog.type = 'SendENS'
            }
            if (this.readonly && event.data && this.tabAms && this.amsIsLink) {
              // 双击回执弹框
              this.ensDataStatusDialog.visible = true
              this.ensDataStatusDialog.jobNo = this.job.jobNo
              this.ensDataStatusDialog.hblNbr2 = this.form.hblNbr2
              this.ensDataStatusDialog.isZh = this.$store.getters.language === 'zh'
              this.ensDataStatusDialog.type = 'SendAMS'
            }
          },
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridColumnEditGroup
          }
        },
        rowData: [],
        gridApi: null,
        isSelected: false
      },
      afr2: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => {
            this.curAfr = event.data
            this.pm.onAfrSelectionChange(event.data)
          },
          onCellDoubleClicked: event => {
            // 只有在非编辑状态下才触发弹窗，避免与编辑冲突
            if (this.readonly && this.afrIsLink) {
              // 双击回执弹框
              this.ensDataStatusDialog.visible = true
              this.ensDataStatusDialog.jobNo = this.job.jobNo
              this.ensDataStatusDialog.hblNbr2 = this.afrForm.hblNbr2
              this.ensDataStatusDialog.isZh = this.$store.getters.language === 'zh'
              this.ensDataStatusDialog.type = 'SendAFR'
            }
          }
        },
        rowData: [],
        gridApi: null,
        isSelected: false
      },
      thailand2: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          onRowClicked: event => {
            this.curAms = event.data
            this.pm.onSelectionChange(event.data)
          },
          onCellFocused: event => {
            const nodes = event.api.rowModel.rowsToDisplay
            this.thailand2.selectedNode = nodes[event.rowIndex] || null
            let data = null
            if (this.thailand2.selectedNode) {
              data = this.thailand2.selectedNode.data
            } else {
              data = new SeaCargoDoc().fillDefaultValue().getData()
              data.docType = CargoDocConsts.THAILAND
            }
            this.pm.onThailandSelectionChange(event, data)
          },
          onSortChanged: event => {
            if (this.thailand2.selectedNode) {
              event.api.setFocusedCell(this.thailand2.selectedNode.rowIndex, event.columnApi.getAllDisplayedColumns()[0])
            }
          }
        },
        rowData: [],
        gridApi: null,
        selectedNode: null
      },
      masterInfo: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      afrContainer: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceTextEditor,
            CargoAgGridAdvanceSelectEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      thailandContainer: {
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: true,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceTextEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      container: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          rowHeight: 32,
          onRowDataChanged: event => {
            // 清除单选行
            event.api.clearFocusedCell()
          },
          context: {
            componentParent: this
          },
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonTextareaEditor,
            CargoAgGridSelectEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceTextEditor
          }
        },
        rowData: [],
        gridApi: null
      },
      afrXmlDialog: {
        visible: false,
        content: ''
      },
      amsXmlDialog: {
        visible: false,
        content: ''
      },
      receiptInfoDialog: {
        visible: false,
        title: 'Receipt',
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null
      },
      tradetechReceiptInfoDialog: {
        visible: false,
        title: 'Receipt',
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          context: {
            componentParent: this
          }
        },
        rowData: [],
        gridApi: null,
        filter: {
          jobUuid: '',
          total: 0,
          pageCount: 0,
          pageNum: 1,
          pageSize: 10,
          jobNo: ''
        }
      },
      currentIndex: 0,
      currentType: '',
      oldAfrNo: '',
      thailandExportDialog: {
        visible: false,
        showReminder: false,
        reminderContent: '',
        content: ''
      },
      jsAfrDeleteDialog: {
        visible: false,
        title: 'Delete Reminder',
        deletionCode: '1',
        deletionReason: 'Cancelation of loading'
      },
      isJs: false,
      ensKey: '',
      ensIndex: 0,
      ensIsEFreight: false,
      ensIsYitong: false,
      ensIsTradetech: false,
      ensIsLink: false,
      amsIsLink: false,
      isChineseLanguage: false,
      isNewWindowByENS: false,
      isYitong: false,
      afrIsOther: false,
      amsIsOther: false,
      afrIsLink: false,
      ensIsOther: false,
      selectorDialog: {
        visible: false,
        title: 'ENS',
        rowData: []
      },
      globalVar: {},
      messagePreviewDialog: {
        visible: false,
        params: {}
      },
      ensDataStatusDialog: {
        visible: false,
        jobNo: '',
        hblNbr2: '',
        isZh: true,
        type: ''
      },
      deleteReasonDialog: {
        visible: false,
        reasonCode: 'Misregistration', // 默认选中"登记错误 - 登记错误"
        reasonDescription: ''
      }
    }
  },
  computed: {
    readonly() {
      if (!this.cooperateEdit) return true
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    thailandEdit() {
      return this.cooperateEdit && this.action !== 'look'
    },
    masterFlag() {
      return this.job.masterFlag
    },
    loadAfrFlag() {
      return this.job.masterFlag || StrUtils.isEmpty(this.job.lclMasterUuid)
    },
    showThailandFlag() {
      return this.job.masterFlag || !this.job.lclMasterUuid
    },
    showExcel() {
      return this.activeTabName === 'ams' || this.activeTabName === 'aci' || this.activeTabName === 'afr' || this.activeTabName === 'ens'
    },
    amsTitle() {
      return this.pm.getNoTitle(false, this.activeTabName)
    },
    amsTitleCn() {
      return this.pm.getNoTitle(true, this.activeTabName)
    },
    ams2FinalRowData() {
      return this.pm.getAmsList()
    },
    afr2FinalRowData() {
      return this.pm.getAfrList()
    },
    tabAfr() {
      return this.activeTabName === 'afr'
    },
    tabAms() {
      return this.activeTabName === 'ams'
    },
    tabAci() {
      return this.activeTabName === 'aci'
    },
    tabIsf() {
      return this.activeTabName === 'isf'
    },
    tabEns() {
      return this.activeTabName === 'ens'
    },
    tabEManifest() {
      return this.activeTabName === 'eManifest'
    },
    isLcl() {
      return this.job.containerLoadType === 'LCL' && StrUtils.isEmpty(this.job.lclMasterUuid)
    },
    /**
     * 只有劲升AMS发送记录中存在发送失败的情况才可点击查询错误信息按钮
     */
    jsError() {
      if (this.isJs && this.activeTabName === 'ams' && this.form.hblNbr2 && this.ams2.rowData) {
        for (const data of this.ams2.rowData) {
          if (data.hblNbr2 === this.form.hblNbr2 && data.jsAmsStatus === 'error') {
            return false
          }
        }
      }
      return true
    },
    sendTypes() {
      if (this.activeTabName === 'ams') {
        if (this.isJs) {
          return this.jsLoadSendType('AMS')
        } else if (this.amsIsLink) {
          return this.linkLoadSendType('AMS')
        } else if (this.amsIsOther) {
          return this.isOtherSendType('AMS')
        } else {
          return this.loadSendType('AMS', 'AMSSTATUS')
        }
      }
      if (this.activeTabName === 'aci') {
        if (this.isJs) {
          return this.jsLoadSendType('ACI')
        } else if (this.amsIsOther) {
          return this.isOtherSendType('ACI')
        } else {
          return this.loadSendType('ACI', 'ACISTATUS')
        }
      }
      if (this.activeTabName === 'isf') {
        if (this.amsIsOther) {
          return this.isOtherSendType('ISF')
        }
        if (this.activeIsfTabName === 'tabBookingISF10') {
          return this.loadSendType('ISF10', 'ISF10STATUS')
        }
        if (this.activeIsfTabName === 'tabBookingISF05') {
          return this.loadSendType('ISF05', 'ISF5STATUS')
        }
      }
      if (this.activeTabName === 'eManifest') {
        if (this.amsIsOther) {
          return this.isOtherSendType('EF')
        }
        return this.loadSendType('EF', 'EFSTATUS')
      }
      if (this.activeTabName === 'afr') {
        if (this.isJs && !this.afrIsOther) {
          return this.jsLoadSendType('AFR')
        } else if (this.afrIsLink) {
          return this.linkLoadSendType('AFR')
        } else {
          return this.loadSendType('AFR', 'afrSendState')
        }
      }
      if (this.activeTabName === 'ens') {
        if (this.ensIsOther) {
          return this.isOtherSendType('ENS')
        }
        return this.loadSendType('ENS', 'ENSSTATUS')
      }
      return null
    },
    receiptColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          headerTooltip: this.amsTitleCn,
          colId: 'hblNbr2',
          field: 'hblNbr2',
          width: 100,
          flex: 1
        },
        {
          headerName: 'Action',
          hide: this.tabEns,
          suppressColumnsToolPanel: this.tabEns,
          headerTooltip: this.$t('SeaExport.Status'),
          colId: 'status',
          field: 'status',
          width: 100,
          flex: 1,
          valueFormatter: params => {
            if (params.value === '0') {
              return 'Send'
            }
            return 'Reseive'
          },
          tooltipValueGetter: (params) => {
            if (params.value === '0') {
              return this.$t('SeaExport.send')
            }
            return this.$t('SeaExport.Receipt')
          }
        },
        {
          headerName: 'Load Status code',
          hide: this.tabEns,
          suppressColumnsToolPanel: this.tabEns,
          headerTooltip: this.$t('SeaExport.ReceiptNumber'),
          colId: 'receiptCode',
          field: 'receiptCode',
          width: 100,
          flex: 1,
          valueFormatter: params => {
            return StrUtils.isEmpty(params.value) ? '-' : params.value
          }
        },
        {
          headerName: this.getItemTitle('Receipt Status'),
          hide: !this.tabEns,
          suppressColumnsToolPanel: !this.tabEns,
          headerTooltip: this.$t('SeaExport.ReceiptNumber'),
          colId: 'receiptCode',
          field: 'receiptCode',
          width: 100,
          flex: 1,
          valueFormatter: params => {
            return StrUtils.isEmpty(this.ensReceipt(params.value)) ? '-' : this.ensReceipt(params.value)
          }
        },
        {
          headerName: this.getItemTitle('Description'),
          headerTooltip: this.$t('CargoMsg.Cargo_Details'),
          colId: 'receiptContent',
          field: 'receiptContent',
          width: 100,
          flex: 1
        },
        {
          headerName: 'Time',
          headerTooltip: this.$t('SeaExport.Time'),
          colId: 'receiptDate',
          field: 'receiptDate',
          width: 100,
          flex: 1
        }
      ]
    },
    tradetechReceiptColumnDefs() {
      return [
        {
          headerName: this.amsTitle,
          headerTooltip: this.amsTitleCn,
          colId: 'hblNbr2',
          field: 'hblNbr2',
          width: 100,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'Soure',
          headerTooltip: this.$t('SeaExport.Source'),
          colId: 'source',
          field: 'source',
          width: 100,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'Receipt Status',
          headerTooltip: this.$t('SeaExport.ReceiptStatus'),
          colId: 'status',
          field: 'status',
          width: 100,
          valueFormatter: params => {
            return StrUtils.isEmpty(params.value) ? '-' : params.value
          }
        },
        {
          headerName: 'Description',
          headerTooltip: this.$t('CargoMsg.Cargo_Details'),
          colId: 'receiptContent',
          field: 'receiptContent',
          width: 100,
          flex: 1,
          valueFormatter: (params) => {
            if (params.data.source === 'Tradetech' && params.data.status && params.data.status.toUpperCase() === 'REJECTED') {
              return this.$t('SeaExport.PleaseReferToTheEmailForSpecificErrorInformation')
            } else {
              return params.value
            }
          },
          filterParams: {},
          filterValueGetter: (params) => {
            if (params.data.source === 'Tradetech') {
              return this.$t('SeaExport.PleaseReferToTheEmailForSpecificErrorInformation')
            } else {
              return params.data.receiptContent
            }
          }
        },
        {
          headerName: 'Source Time',
          headerTooltip: this.$t('SeaExport.ReceiptTime'),
          colId: 'receiptDate',
          field: 'receiptDate',
          minWidth: 150,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'Time',
          headerTooltip: this.$t('SeaExport.Time'),
          colId: 'fileTime',
          field: 'fileTime',
          minWidth: 150,
          tooltipValueGetter: (params) => params.value
        }
      ]
    },
    deleteReasonOptions() {
      return [
        {
          value: 'Cancelation',
          label: this.$store.getters.language === 'zh' ? '取消 - 装货取消' : 'Cancelation - Cancelation of loading'
        },
        {
          value: 'Change',
          label: this.$store.getters.language === 'zh' ? '更改 - 提单号更改' : 'Change - Change of B/L number'
        },
        {
          value: 'Misregistration',
          label: this.$store.getters.language === 'zh' ? '登记错误 - 登记错误' : 'Misregistration - Misregistration'
        },
        {
          value: 'Other',
          label: this.$store.getters.language === 'zh' ? '其他 - 其他原因' : 'Other - Other reasons'
        }
      ]
    },
    deleteReasonRules() {
      return {
        reasonCode: [
          { required: true, message: '请选择删除原因', trigger: 'change' }
        ],
        reasonDescription: [
          {
            validator: (rule, value, callback) => {
              if (this.deleteReasonDialog.reasonCode === 'Other' && (!value || value.trim() === '')) {
                callback(new Error('请填写原因具体说明'))
              } else {
                callback()
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    'job.masterFlag': {
      handler: function(val, oldVal) {
        if (val) {
          document.getElementById('tab-ams').style.display = 'none'
          document.getElementById('tab-isf').style.display = 'none'
          document.getElementById('tab-aci').style.display = 'none'
          document.getElementById('tab-eManifest').style.display = 'none'
          document.getElementById('tab-afr').style.display = 'inline-block'
        } else {
          document.getElementById('tab-ams').style.display = 'inline-block'
          document.getElementById('tab-isf').style.display = 'inline-block'
          document.getElementById('tab-aci').style.display = 'inline-block'
          document.getElementById('tab-eManifest').style.display = 'inline-block'
          if (this.job.lclMasterUuid) {
            document.getElementById('tab-afr').style.display = 'none'
          } else {
            document.getElementById('tab-afr').style.display = 'inline-block'
          }
        }
      },
      deep: true
    },
    'job.carrierId': {
      handler: function(val, oldVal) {
        if (val) {
          this.pm.syncAmsCarrierEori()
        }
      },
      deep: true
    },
    amsCheck(val) {
      LocalStorageUtils.setConfiguration('AMS_CHECK', val)
    },
    activeTabName(val) {
      if (val === 'afr') {
        this.amsCheck = true
      }
    }
  },
  async created() {
    await cache.load(cacheName.CONFIG)
    const cacheConfig = cache.config
    this.amsInterfaceName = cacheConfig.get('AMSInterfaceName')
    this.deleteAMS = parseInt(cacheConfig.get('DeleteAMS')) === 1
    this.isTradetech = cacheConfig.get('AMSInterfaceName') === 'tradetech'
    this.isChineseLanguage = Number(cacheConfig.get('AntiTerrorismShippingAfrLanguageSwitching')) === 1
    // CARGO-49127 参数控制ENS新页面展示 新的界面针对参数配置为yitong、other的生效，配置为tradetech和eFreight的维持原样不变
    const ENSSupplierConfiguration = cacheConfig.get('ENSSupplierConfiguration')
    this.isNewWindowByENS = ENSSupplierConfiguration === 'yitong' || ENSSupplierConfiguration === 'other' || ENSSupplierConfiguration === 'link'
    this.isYitong = ENSSupplierConfiguration === 'yitong'
    const amsCheck = LocalStorageUtils.getConfiguration('AMS_CHECK')
    this.amsCheck = amsCheck === '' ? true : amsCheck
    this.pm.init()
    this.getAfrAccount()
  },
  methods: {
    async onShow(row, isRefresh) {
      this.localData.importDifferentField = null
      if (!isRefresh) {
        this.pm.showCarrierAgentScac()
        return
      }
      this.localData.vesselList = await loadSpecificBasicInfo('Vessel').then(res => res.data)
      this.job = row
      if (this.isEdit) {
        isfPassengerApi.getISFPassengersAll({ customerId: this.job.customerId }).then(resp => {
          if (resp.data) {
            for (const isf of resp.data) {
              const index = this.partyNameList.findIndex(p => p.partyName === isf.partyName)
              if (index === -1 && isf.isfType !== 1) {
                this.partyNameList.push(isf)
              }
            }
          }
        })
        if (this.tabEManifest) {
          this.$refs.eManifest.initPartyNames()
        }
      }
      if (this.masterFlag) {
        if (this.activeTabName !== 'afr' && this.activeTabName !== 'thailand') {
          this.activeTabName = 'afr'
        }
      } else if (this.initJobUuid !== this.job.uuid) {
        const dischargingPort = getObjectByCache(TYPE_NAMES.basic_data_Seaport, 'code', this.job.dischargingPortCode)
        let countryCode = ''
        if (dischargingPort) {
          countryCode = dischargingPort.countryCode
        }
        if (countryCode && countryCode === 'JP') {
          this.activeTabName = 'afr'
        } else {
          this.activeTabName = 'ams'
        }
      }
      this.initJobUuid = this.job.uuid
      await this.pm.changeJob()
      this.$nextTick(async() => {
        if (!this.job.masterFlag) {
          await ensureExecuteSuccess(() => this.ams2.gridApi)
          let selectedNode = null
          const { rowsToDisplay } = this.ams2.gridApi.getModel()
          if (this.curAms) {
            selectedNode = rowsToDisplay.find(node => node.data.hblNbr2 === this.curAms.hblNbr2) || rowsToDisplay[0]
          } else {
            selectedNode = rowsToDisplay[0]
          }
          const selectedData = selectedNode ? selectedNode.data : this.ams2.rowData[0]
          if (selectedNode) {
            selectedNode.setSelected(true)
          }
          await this.pm.onSelectionChange(selectedData)
        }
        if (this.loadAfrFlag) {
          await ensureExecuteSuccess(() => this.afr2.gridApi)
          if (this.afr2?.gridApi) {
            let selectedAfrNode = null
            const afrRowData = []
            this.afr2.gridApi.forEachNode(node => afrRowData.push(node))
            if (this.curAfr) {
              selectedAfrNode = afrRowData.find(node => node.data.hblNbr2 === this.curAfr.hblNbr2) || afrRowData[0]
            } else {
              selectedAfrNode = afrRowData[0]
            }
            const selectedAfrData = selectedAfrNode ? selectedAfrNode.data : this.afr2.rowData[0]
            if (selectedAfrNode) {
              selectedAfrNode.setSelected(true)
            }
            await this.pm.onAfrSelectionChange(selectedAfrData)
          }
        }
        this.afrForm.frob = this.afrForm.frob ? this.afrForm.frob : 'I'
        this.afrForm.goodsType = this.afrForm.goodsType ? this.afrForm.goodsType : 0
        this.afrForm.destinationPortCode = this.afrForm.destinationPortCode ? this.afrForm.destinationPortCode : this.job.destinationPortCode
        // 如果没值，默认显示第一个选项
        // ams/isf、申报类型 申报账户 提单类型 发货类型
        this.form.AMSType = this.form.AMSType ? this.form.AMSType : 0
        this.form.frob = this.form.frob ? this.form.frob : 'I'
        this.form.paperlessInBondParticipant = this.form.paperlessInBondParticipant ? this.form.paperlessInBondParticipant : 1
        this.form.emainAccount = this.form.emainAccount ? this.form.emainAccount : this.localData.eFreighsAmsList ? this.localData.eFreighsAmsList[0] : ''
        this.form.emainAccountAci = this.form.emainAccountAci ? this.form.emainAccountAci : this.localData.eFreighsAciList ? this.localData.eFreighsAciList[0] : ''
        this.form.amsBlType = this.form.amsBlType ? this.form.amsBlType : AmsBLType.Ams_BL_Type[0].code
        this.form.shipmentTypeCode = this.form.shipmentTypeCode ? this.form.shipmentTypeCode : ShipmentTypeCode.Shipment_Type_Code[0].code

        if (this.tabEns && this.isNewWindowByENS) {
          // 申报人 是，默认选中权限设置，反恐舱单设置中维护的第一个EORI
          if (this.form.afrAddress[0]) {
            // 并且设置 form.docType为AMS
            this.form.docType = 'AMS'
            const addressForm = this.form.afrAddress[0]

            // 处理申报人信息
            if (this.localData.officeEoriList && this.localData.officeEoriList.length) {
              const officeEori = this.localData.officeEoriList[0]
              this.form.declarantEori = officeEori.eori
              // 申报人也就是承运人相关赋值
              addressForm.carrierName = officeEori.name
              addressForm.carrierAddress1 = officeEori.address1
              addressForm.carrierAddress2 = officeEori.address2
              addressForm.carrierStreetNo = officeEori.streetNo
              addressForm.carrierPostalcode = officeEori.postalcode
              addressForm.carrierEmail = officeEori.email
              addressForm.carrierTel = officeEori.tel
              addressForm.carrierCity = officeEori.city
              addressForm.carrierCountry = officeEori.country
            }

            // 收货人、发货人、卖家、买家  类型	默认选中Legal person | 法人
            if (!addressForm.shipperTypeOfPerson) {
              addressForm.shipperTypeOfPerson = '1'
            }
            if (!addressForm.consigneeTypeOfPerson) {
              addressForm.consigneeTypeOfPerson = '1'
            }
            if (!addressForm.sellerTypeOfPerson) {
              addressForm.sellerTypeOfPerson = '1'
            }
            if (!addressForm.buyerTypeOfPerson) {
              addressForm.buyerTypeOfPerson = '1'
            }
          }
        }
        if (!this.job.masterFlag) {
          this.pm.loadAms()
        }
        if (this.loadAfrFlag) {
          this.pm.loadAfr()
        }
      })
      this.getAfrAccount()
    },
    loadSendType(type, statusField) {
      const current = this.tabAfr ? this.job : this.curAms
      if (!current) {
        return []
      }
      const status = this.tabAfr ? current[statusField] === 2 : current[statusField] === 1
      const sendTypes = [
        { label: this.$t('SeaExport.Original'), type: type, enabled: !status, index: 0 },
        { label: this.$t('SeaExport.Correct'), type: type, enabled: status, index: 1 }
      ]
      if (this.deleteAMS && this.isTradetech && type === 'AMS') {
        sendTypes.push({ label: this.$t('SeaExport.DeleteCustoms'), type: type, enabled: !status, index: 3 })
        sendTypes.push({ label: this.$t('SeaExport.DeleteAll'), type: type, enabled: !status, index: 4 })
      } else {
        sendTypes.push({ label: this.$t('SeaExport.Delete'), type: type, enabled: status, index: 2 })
      }
      if (this.afrIsOther && type === 'AFR') {
        return [
          { label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 },
          { label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 },
          { label: this.$t('SeaExport.Delete'), type: type, enabled: true, index: 2 }
        ]
      }
      if (type === 'ENS') {
        if (this.ensIsTradetech) {
          return [
            { label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 },
            { label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 },
            { label: this.$t('SeaExport.DeleteCustoms'), type: type, enabled: true, index: 3 },
            { label: this.$t('SeaExport.DeleteAll'), type: type, enabled: true, index: 4 }
          ]
        } else if (this.ensIsLink) {
          return [
            { label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 },
            { label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 },
            { label: this.$t('SeaExport.Delete'), type: type, enabled: true, index: 2 }
          ]
        } else {
          return [
            { label: this.$t('SeaExport.SaveOnly'), type: type, enabled: true, index: 6 },
            { label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 },
            { label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 },
            { label: this.$t('SeaExport.Delete'), type: type, enabled: true, index: 2 }
          ]
        }
      }
      return sendTypes
    },
    jsLoadSendType(type) {
      const sendTypes = []
      sendTypes.push({ label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 })
      sendTypes.push({ label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 })
      sendTypes.push({ label: this.$t('SeaExport.Delete'), type: type, enabled: true, index: 2 })
      if (type === 'AFR') {
        sendTypes.push({ label: this.$t('SeaExport.LateOriginal'), type: type, enabled: true, index: 5 })
      }
      return sendTypes
    },
    linkLoadSendType(type) {
      const sendTypes = []
      sendTypes.push({ label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 })
      sendTypes.push({ label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 })
      sendTypes.push({ label: this.$t('SeaExport.Delete'), type: type, enabled: true, index: 2 })
      return sendTypes
    },
    isOtherSendType(type) {
      const sendTypes = []
      sendTypes.push({ label: this.$t('SeaExport.Original'), type: type, enabled: true, index: 0 })
      sendTypes.push({ label: this.$t('SeaExport.Correct'), type: type, enabled: true, index: 1 })
      sendTypes.push({ label: this.$t('SeaExport.Delete'), type: type, enabled: true, index: 2 })
      return sendTypes
    },
    importAMSExcel(item) {
      if (!this.curAms) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.oldAmsNo = this.curAms.hblNbr2
      const param = {
        file: item.file,
        jobUuid: this.job.uuid,
        importContainer: !this.isLcl,
        interfaceName: cache.config.get('AMSInterfaceName')
      }
      let isSend = false
      for (const row of this.ams2.rowData) {
        if (row.AMSSTATUS === 1) {
          isSend = true
          break
        }
        if (row.EFSTATUS === 1) {
          isSend = true
          break
        }
        if (row.ISF5STATUS === 1) {
          isSend = true
          break
        }
        if (row.ISF10STATUS === 1) {
          isSend = true
          break
        }
      }
      if (isSend) {
        this.$confirm(this.$t('Message.ThePacketHasBeenSentAndWhetherToImportItAgain'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          importAmsExcel(param).then(response => {
            this.importResult(response)
          })
        }).catch()
      } else {
        importAmsExcel(param).then(response => {
          this.importResult(response)
        })
      }
    },
    importResult(response) {
      if (response.data == null || response.data === '') {
        this.$message.warning(this.$t('SeaExport.FileContentWrong'))
      } else {
        const errorMsg = response.data.errorMsg
        if (!StrUtils.isEmpty(errorMsg)) {
          this.$confirm(this.$t('SeaExport.ThereAreTheFollowingExceptionsInTheImportDataPleaseCheckTheDataInTheForm') + '</br></br>' + errorMsg, this.$t('Message.SystemAlert'), {
            dangerouslyUseHTMLString: true,
            showClose: false,
            showCancelButton: false,
            confirmButtonText: this.$t('common.btn.ok'),
            type: 'warning'
          }).then(() => {
            this.importResultHandler(response)
            // 定位到该列
          }).catch(() => {
            this.importResultHandler(response)
          })
        } else {
          this.importResultHandler(response)
        }
      }
    },
    importResultHandler(response) {
      if (this.tabIsf) {
        this.saveIsfImportData(response.data)
        return
      }
      if (this.tabEns) {
        this.saveEnsImportData(response.data)
      }
      if (this.isLcl) {
        this.$message.warning(this.$t('SeaExport.NoPrimaryTicketIsAssociatedSoTheContainerDataCannotBeImported'))
      }
      if (this.container.rowData && this.container.rowData.length > 0) {
        const canUse = this.container.rowData.filter(p => !p.deleted)
        if (canUse && canUse.length > 0) {
          this.$confirm(this.$t('SeaExport.ImportContainerInformation'), this.$t('Message.Prompt'), {
            dangerouslyUseHTMLString: true,
            confirmButtonText: this.$t('common.btn.ok'),
            type: 'warning'
          }).then(() => {
            if (this.tabAfr) {
              this.saveAfrImportData(response.data)
            } else if (this.tabEManifest) {
              this.saveEManifestImportData(response.data)
            } else {
              this.saveImportData(response.data)
            }
            // 定位到该列
          }).catch(() => {
            const result = response.data
            delete result.ediContainer
            this.saveImportData(result, false)
            if (this.tabAfr) {
              this.saveAfrImportData(response.data, false)
            } else if (this.tabEManifest) {
              this.saveEManifestImportData(response.data)
            } else {
              this.saveImportData(response.data, false)
            }
          })
        } else {
          if (this.tabAfr) {
            this.saveAfrImportData(response.data)
          } else if (this.tabEManifest) {
            this.saveEManifestImportData(response.data)
          } else {
            this.saveImportData(response.data)
          }
        }
      } else {
        if (this.tabAfr) {
          this.saveAfrImportData(response.data)
        } else if (this.tabEManifest) {
          this.saveEManifestImportData(response.data)
        } else {
          this.saveImportData(response.data)
        }
      }
    },
    beforeUpload(file) {
      const fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    getSubmitData() {
      for (const item of this.cargoDocs) {
        if (this.form.docType === CargoDocConsts.AMS || this.form.docType === CargoDocConsts.AFR) {
          JobUtils.handlingSpecialCharactersForCargoDoc(item)
        }
        if (this.form.docType === CargoDocConsts.AMS && this.activeTabName === 'eManifest') {
          const passenger = item.isfPassenger?.find(p => p.partyName === item.partyName)
          if (passenger) {
            passenger.partyCode = item.partyCode
            passenger.addressLine = item.partyAddressLine
            passenger.countryCode = item.partyCountryCode
            passenger.city = item.partyCity
            passenger.subDivisionCode = item.partyProvince
            passenger.postalCode = item.partyZipCode
          }
        }
        this.pm.validateForm(item)
      }
      for (const item of this.thailandCargoDocs) {
        if (!item.hblNbr2) {
          throw new TabError(this.view.$t('Message.HAWBAfrCannotBeNull'), 'tabAMS')
        } else if (!this.pm.checkHblNbr2(item)) {
          throw new TabError(this.view.$t('Message.HAWBAfrCannotBeRepeated'), 'tabAMS')
        }
      }
      this.pm.executeTask()
      this.pm.fillModel()
      this.localData.importDifferentField = null
      return {
        seaCargoDoc: this.cargoDocs.concat(this.afrCargoDocs).concat(this.thailandCargoDocs)
      }
    },
    async saveImportData(item, importContainer = true) {
      item.mbl = item.mblNbr2
      if (!this.tabEns) {
        item.vesselIMO = StrUtils.isEmpty(item.vessel) ? '' : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', item.vessel, 'imoCode')
      }
      if (this.isJs && (this.tabAms || this.tabAci || this.tabAfr)) {
        item.containerLoadType = this.form.containerLoadType
        item.dispatchingPlaceCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'englishName', item.dispatchingPlaceCode, 'code')
        item.loadingPortCode = ColumnUtils.resolveSpecificField(this.localData.jsPortList, 'name', item.loadingPortCode, 'code')
        item.dischargingPortCode = ColumnUtils.resolveSpecificField(this.localData.jsAmsDischargingList, 'name', item.dischargingPortCode, 'code')
        item.destinationPortCode = ColumnUtils.resolveSpecificField(this.localData.jsPortList, 'name', item.destinationPortCode, 'code')
        item.firstPortOfCallCode = ColumnUtils.resolveSpecificField(this.localData.jsPortList, 'name', item.firstPortOfCallCode, 'code')
        item.lastAbroadProd = ColumnUtils.resolveSpecificField(this.localData.jsPortList, 'name', item.lastAbroadProd, 'code')
        item.nationalityCodeofVessel = ColumnUtils.resolveSpecificField(this.localData.jsCountry, 'code', item.nationalityCodeofVessel, 'code')
        item.cargoDestinationCountry = ColumnUtils.resolveSpecificField(this.localData.jsCountry, 'code', item.cargoDestinationCountry, 'code')
      }
      this.compare(item, this.form)
      // 基本信息
      this.form.hblNbr2 = item.hblNbr2
      this.form.vesselIMO = item.vesselIMO
      this.form.mbl = item.mblNbr2
      if (!this.isJs) {
        this.form.containerLoadType = item.containerLoadType
      }
      this.form.loadingPortCode = item.loadingPortCode
      this.form.dischargingPortCode = item.dischargingPortCode
      this.form.destinationPortCode = item.destinationPortCode
      this.form.loadingPort = item.loadingPort
      this.form.dischargingPort = item.dischargingPort
      this.form.destinationPort = item.destinationPort
      this.form.etd = item.etd
      this.form.eta = item.eta
      this.form.vessel = item.vessel
      this.form.voyageFlight = item.voyageFlight
      this.txtCarrierScAc = item.scacCode
      // this.txtBookingAgentScAc = item.scacCode
      this.form.cargoEnglishName = item.cargoEnglishName
      if (this.isJs && (this.tabAms || this.tabAci || this.tabAfr)) {
        this.form.mark = item.mark
        this.form.dispatchingPlace = item.dispatchingPlace
        this.form.dispatchingPlaceCode = item.dispatchingPlaceCode
        this.form.loadingPortCode = item.loadingPortCode
        this.form.dischargingPortCode = item.dischargingPortCode
        this.form.destinationPortCode = item.destinationPortCode
        this.form.paperlessInBondParticipant = item.paperlessInBondParticipant
        this.form.firstPortOfCallCode = item.firstPortOfCallCode
        this.form.firstPortOfCall = item.firstPortOfCall
        this.form.lastAbroadProd = item.lastAbroadProd
        this.form.lastAbroadProdName = item.lastAbroadProdName
        this.form.nationalityCodeofVessel = item.nationalityCodeofVessel
        this.form.goodsType = item.goodsType
        this.form.hazardousCode = item.hazardousCode
        this.form.undgCode = item.undgCode
        this.form.cargoDestinationCountry = item.cargoDestinationCountry
        this.form.cargoDestinationCity = item.cargoDestinationCity
        this.form.flashPointTemp = item.flashPointTemp
      }

      // 填充反恐地址信息
      this.syncAfrAddress(item.afrAddress[0])
      // 装箱信息
      const oldContainers = this.container.rowData
      if (importContainer) { // 导入装箱信息
        if (oldContainers && oldContainers.length > 0) {
          for (const row of oldContainers) {
            row['deleted'] = true
          }
        }
      }
      let packing = ''
      const containerInfo = item.ediContainer
      if (containerInfo && containerInfo.length > 0) {
        packing = containerInfo[0].unitType
        if (this.form.hasOwnProperty('packing') && this.form['packing'] !== packing && !StrUtils.isEmpty(packing)) {
          this.localData.importDifferentField['packing'] = true
        } else {
          delete this.localData.importDifferentField['packing']
        }
        if (!StrUtils.isEmpty(packing)) {
          const packingList = await getSpecificBasicData(TYPE_NAMES.basic_data_Packing)
          const pack = packingList.find(p => p.isoCode === packing || p.name === packing)
          this.form.packing = (pack) ? pack.code : ''
        }
        for (const row of containerInfo) {
          if (this.isJs && (this.tabAms || this.tabAci || this.tabAfr)) {
            row.packing = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', row.packing, 'code')
            row.eqCode = ColumnUtils.resolveSpecificField([...SystemConstants.JS_AFR_CONTAINER_SIZE], 'englishName', row.eqCode, 'code')
          }
          row['containerUsageUuid'] = null
          oldContainers.push(row)
        }
      }
      if (this.isJs && (this.tabAms || this.tabAci || this.tabAfr)) {
        item.packing = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Packing, 'name', item.packing, 'code')
        if (this.form.hasOwnProperty('packing') && this.form['packing'] !== item.packing && !StrUtils.isEmpty(item.packing)) {
          this.localData.importDifferentField['packing'] = true
        } else {
          delete this.localData.importDifferentField['packing']
        }
        this.form.packing = item.packing
      }
      this.container.rowData = oldContainers
      this.container.gridOptions.api.clearFocusedCell()
      this.container.gridOptions.api.refreshCells({ force: true })
      // 计算件毛体
      this.calculateQwc()
      this.form.frob = 'I'
      this.pm.loadAms()
      this.pm.refAmsData()
      // 修改列表里的ams no
      // const currentOfficeId = this.$store.getters.currentOfficeId
      // const officeModel = Office.getOfficeById(currentOfficeId)
    },
    async saveEManifestImportData(item, importContainer = true) {
      this.compare(item, this.form)
      // 基本信息
      this.form.hblNbr2 = item.hblNbr2
      this.form.containerLoadType = item.containerLoadType
      this.form.customerType = item.customerType
      this.form.htsCode = item.htsCode
      this.form.mblNbr2 = item.mblNbr2
      this.form.vesselIMO = item.vesselIMO
      this.form.frob = item.frob
      this.form.mbl = item.mbl
      this.form.loadingPortCode = item.loadingPortCode
      this.form.dischargingPortCode = item.dischargingPortCode
      this.form.destinationPortCode = item.destinationPortCode
      this.form.loadingPort = item.loadingPort
      this.form.dischargingPort = item.dischargingPort
      this.form.destinationPort = item.destinationPort
      this.form.etd = item.etd
      this.form.eta = item.eta
      this.form.vessel = item.vessel
      this.form.voyageFlight = item.voyageFlight
      this.efNvoccScac = item.scacCode
      this.form.cargoEnglishName = item.cargoEnglishName
      this.form.mark = item.mark
      this.form.dispatchingPlace = item.dispatchingPlace
      this.form.dispatchingPlaceCode = item.dispatchingPlaceCode
      this.form.firstPortOfCallCode = item.firstPortOfCallCode
      this.form.firstPortOfCall = item.firstPortOfCall
      this.form.lastAbroadProd = item.lastAbroadProd
      this.form.lastAbroadProdName = item.lastAbroadProdName
      this.form.etaFirstPortOfCall = item.etaFirstPortOfCall
      this.form.recordNumber = item.recordNumber
      this.form.freightTermHBL = item.freightTermHBL
      this.localData.dishSubLocStr = item.dishSubLoc
      this.localData.subLocationCodeStr = item.subLocationCode
      this.localData.txtCarrierScAc = item.carrierCode

      // 填充反恐地址信息
      this.syncAfrAddress(item.afrAddress[0])
      // 装箱信息
      const oldContainers = this.container.rowData
      if (importContainer) { // 导入装箱信息
        if (oldContainers && oldContainers.length > 0) {
          for (const row of oldContainers) {
            row['deleted'] = true
          }
        }
      }
      let packing = ''
      const containerInfo = item.ediContainer
      if (containerInfo && containerInfo.length > 0) {
        packing = containerInfo[0].unitType
        if (this.form.hasOwnProperty('packing') && this.form['packing'] !== packing && !StrUtils.isEmpty(packing)) {
          this.localData.importDifferentField['packing'] = true
        } else {
          delete this.localData.importDifferentField['packing']
        }
        if (!StrUtils.isEmpty(packing)) {
          const packingList = await getSpecificBasicData(TYPE_NAMES.basic_data_Packing)
          const pack = packingList.find(p => p.isoCode === packing || p.name === packing)
          this.form.packing = (pack) ? pack.code : ''
        }
        for (const row of containerInfo) {
          row['containerUsageUuid'] = null
          oldContainers.push(row)
        }
      }
      this.container.rowData = oldContainers
      this.container.gridOptions.api.clearFocusedCell()
      this.container.gridOptions.api.refreshCells({ force: true })
      // 计算件毛体
      this.calculateQwc()
      this.pm.loadAms()
      this.pm.refAmsData()
    },
    async saveIsfImportData(item) {
      this.compare(item, this.form)
      this.form.hblNbr2 = item.hblNbr2
      this.form.mbl = item.mbl
      this.form.etd = item.etd
      this.form.eta = item.eta
      this.form.amsBlType = item.amsBlType
      this.form.shipmentTypeCode = item.shipmentTypeCode
      this.form.countryOrigin = item.countryOrigin
      this.form.hsCode = item.hsCode
      this.form.dischargingPort = item.dischargingPort
      this.form.destinationPortCode = item.destinationPortCode
      this.form.destinationPort = item.destinationPort
      this.form.lastAbroadProd = item.lastAbroadProd
      this.form.lastAbroadProdName = item.lastAbroadProdName
      this.form.nvoccScac = item.scacCode
      this.localData.txtCarrierScAc = item.carrierCode

      const oldIsfPassengers = this.form.isfPassenger
      if (oldIsfPassengers && oldIsfPassengers.length > 0) {
        for (const row of oldIsfPassengers) {
          if (item.isfType === 'isf5' && row.isfType === 5) {
            row.opType = 'del'
          } else if (item.isfType === 'isf10' && row.isfType === 10) {
            row.opType = 'del'
          }
        }
      }
      for (const passenger of item.isfPassenger) {
        passenger.customerId = this.job.customerId
        passenger.opOffice = this.job.opOffice
        passenger.opType = 'add'
        oldIsfPassengers.push(passenger)
      }
      this.form.isfPassenger = oldIsfPassengers
      for (let i = 0; i < this.cargoDocs.length; i++) {
        if (this.form === this.cargoDocs[i]) {
          this.form = {
            ...this.form
          }
          this.cargoDocs[i] = this.form
        }
      }
    },

    saveEnsImportData(item) {
      if (this.ensIsEFreight) {
        this.form.declarationType = item.declarationType
      }
      if (this.ensIsTradetech) {
        this.form.ensDeclarationData = item.ensDeclarationData
      }
      this.form.goodsType = item.goodsType
      this.form.declarantEori = item.declarantEori
      this.form.declaringMemberCountry = item.declaringMemberCountry
      this.form.chargesPaymentMethod = item.chargesPaymentMethod
      this.$refs['ens'].deleteAllCargoInfo()
      this.form.ensCargoInfo = item.ensCargoInfo
      // 初始化途径国
      this.form.routeCountryList = []
      if (item.routeCountry) {
        const rout = item.routeCountry.split(',')
        for (const item of rout) {
          this.form.routeCountryList.push({
            country: item
          })
        }
      }
      this.form.carrierEori = item.carrierEori
    },
    getContainerMap(oldContainers) {
      if (!oldContainers || oldContainers.length === 0) {
        return null
      }
      const containerMap = {}
      for (const container of oldContainers) {
        containerMap[container.containerNo] = container
      }
      return containerMap
    },
    syncAfrAddress(importData) {
      let afrAddress
      if (this.tabAfr) {
        afrAddress = this.afrForm.afrAddress[0]
      } else {
        afrAddress = this.form.afrAddress[0]
      }
      delete importData.uuid
      delete importData.version
      delete importData.state
      delete importData.cargoDocUuid
      delete importData.docType
      for (const key in importData) {
        if (afrAddress.hasOwnProperty(key) && importData[key] !== afrAddress[key]) {
          afrAddress[key] = importData[key]
        }
      }
    },
    compare(importData, doc = {}) {
      const differentFields = {}
      for (const key in importData) {
        if (key === 'afrAddress') {
          differentFields['afrAddress'] = {}
          const diffAfrAddressField = differentFields['afrAddress']
          const importAfrAddress = importData.afrAddress[0]
          let afrAddress
          if (this.tabAfr) {
            afrAddress = this.afrForm.afrAddress[0]
          } else {
            afrAddress = this.form.afrAddress[0]
          }
          for (const addressKey in importAfrAddress) {
            if (importAfrAddress[addressKey] && afrAddress.hasOwnProperty(addressKey) &&
              importAfrAddress[addressKey] !== afrAddress[addressKey] &&
            importAfrAddress[addressKey] !== afrAddress[addressKey].replace('\r', '')) {
              diffAfrAddressField[addressKey] = true
            }
          }
          continue
        }
        if (doc.hasOwnProperty(key) && doc[key] !== importData[key]) {
          if (key === 'cargoEnglishName') {
            if (doc[key].replace('\r', '') !== importData[key]) {
              differentFields[key] = true
            }
          } else {
            differentFields[key] = true
          }
        }
      }
      this.localData.importDifferentField = differentFields
    },
    calculateQwc() {
      let quantityTotal = 0
      let weightTotal = 0.0
      let cubageTotal = 0.0
      for (const row of this.container.rowData) {
        if (row.deleted) {
          continue
        }
        quantityTotal += row.quantity
        weightTotal += row.weight
        cubageTotal += row.cubage
      }
      this.compareField('quantity', quantityTotal)
      this.compareField('weight', weightTotal)
      this.compareField('cubage', cubageTotal)
      this.form.quantity = quantityTotal
      this.form.weight = weightTotal
      this.form.cubage = cubageTotal
    },
    compareField(field, value) {
      if (this.form[field] !== value && roundHalfUp(this.form[field]) !== roundHalfUp(value)) {
        this.localData.importDifferentField[field] = true
      } else {
        delete this.localData.importDifferentField[field]
      }
    },
    onDownloadTemplateRelease() {
      let folderName = 'booking'
      if (this.isJs) {
        folderName += '/js'
      }
      if (this.tabAfr) {
        ExportUtils.downloadTemplateFile('AFRTemplate.xlsx', folderName)
        return
      }
      if (this.tabAci) {
        ExportUtils.downloadTemplateFile('ACITemplate.xlsx', folderName)
        return
      }
      if (this.tabEManifest) {
        ExportUtils.downloadTemplateFile('eManifestTemplate.xlsx', folderName)
        return
      }
      if (this.tabEns) {
        ExportUtils.downloadTemplateFile('ENSTemplate.xlsx', folderName)
        return
      }
      ExportUtils.downloadTemplateFile('AMSTemplate.xlsx', folderName)
    },
    // 组装打印参数
    getPrintData() {
      let printData = this.form
      if (this.activeTabName === 'afr') {
        printData = this.afrForm
      } else if (this.activeTabName === 'thailand') {
        printData = this.thailandForm
      }
      if (!printData || !printData.uuid) {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
        return
      }
      const params = {}
      params.BLNbr2 = printData.hblNbr2
      params.cargoDocUuid = printData.uuid
      params.DOC_UUID = printData.uuid
      params.category = 'AMS'
      params.ctx = new SeaCargoDoc(printData)
      return params
    },
    jumpToCargo() {
      const jobNo = this.job.jobNo
      const jumpCargoUrl = this.getCargoJumpUrl({
        code: 'fmBookingNew',
        jobNo: jobNo,
        language: store.getters.language,
        sessionId: store.getters.token,
        branchId: store.getters.currentOfficeId,
        departmentId: store.getters.currentDeptId
      })
      window.open(jumpCargoUrl, '_blank')
    },
    getCargoJumpUrl({ code, jobNo, language, sessionId, branchId, departmentId }) {
      const url = `${process.env.VUE_APP_CARGO}/ssoForward?sessionId=${sessionId || store.getters.currentUserInfo.sessionId}&branchId=${branchId || store.getters.currentOfficeId}&departmentId=${departmentId || store.getters.currentDeptId}&language=${language || store.getters.language}&module=${code}&jobNo=${jobNo}`
      return url
    },
    importAFRExcel(item) {
      if (!this.curAfr) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.oldAfrNo = this.curAfr.hblNbr2
      const param = {
        file: item.file,
        jobUuid: this.job.uuid,
        importContainer: !this.isLcl,
        interfaceName: cache.config.get('AMSInterfaceName')
      }
      let isSend = false
      for (const row of this.afr2.rowData) {
        if (row.afrStatus === 1) {
          isSend = true
          break
        }
      }
      if (isSend) {
        this.$confirm(this.$t('Message.ThePacketHasBeenSentAndWhetherToImportItAgain'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          importAfrExcel(param).then(response => {
            this.importResult(response)
          })
        }).catch()
      } else {
        importAfrExcel(param).then(response => {
          this.importResult(response)
        })
      }
    },
    async saveAfrImportData(item, importContainer = true) {
      item.mbl = item.mblNbr2
      item.vesselIMO = StrUtils.isEmpty(item.vessel) ? '' : ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Vessel, 'englishName', item.vessel, 'imoCode')
      if (this.isJs) {
        item.dispatchingPlaceCode = ColumnUtils.resolveSpecificField(this.localData.jsAfrPortList, 'name', item.dispatchingPlaceCode, 'code')
        item.loadingPortCode = ColumnUtils.resolveSpecificField(this.localData.jsAfrPortList, 'name', item.loadingPortCode, 'code')
        item.dischargingPortCode = ColumnUtils.resolveSpecificField(this.localData.jsAfrPortList, 'name', item.dischargingPortCode, 'code')
        item.destinationPortCode = ColumnUtils.resolveSpecificField(this.localData.jsAfrPortList, 'name', item.destinationPortCode, 'code')
        item.hazardousCode = ColumnUtils.resolveSpecificField(this.localData.jsAfrDangerous, 'name', item.hazardousCode, 'code')
        item.cargoDestinationCountry = ColumnUtils.resolveSpecificField(this.localData.jsCountry, 'code', item.cargoDestinationCountry, 'code')
        item.nationalityCodeofVessel = ColumnUtils.resolveSpecificField(this.localData.jsCountry, 'code', item.nationalityCodeofVessel, 'code')
      }
      this.compare(item, this.afrForm)
      // 基本信息
      this.afrForm.hblNbr2 = item.hblNbr2
      this.afrForm.mbl = item.mblNbr2
      this.afrForm.containerLoadType = item.containerLoadType
      this.afrForm.dispatchingPlace = item.dispatchingPlace
      this.afrForm.dispatchingPlaceCode = item.dispatchingPlaceCode
      this.afrForm.loadingPortCode = item.loadingPortCode
      this.afrForm.dischargingPortCode = item.dischargingPortCode
      this.afrForm.destinationPortCode = item.destinationPortCode
      this.afrForm.loadingPort = item.loadingPort
      this.afrForm.dischargingPort = item.dischargingPort
      this.afrForm.destinationPort = item.destinationPort
      this.afrForm.etd = item.etd
      this.afrForm.eta = item.eta
      this.afrForm.vessel = item.vessel
      this.afrForm.vesselCode = item.vesselCode
      this.afrForm.voyageFlight = item.voyageFlight
      this.afrForm.quantity = item.quantity
      this.afrForm.weight = item.weight
      this.afrForm.cubage = item.cubage
      this.afrForm.hsCode = item.hsCode
      if (this.isJs) {
        this.afrForm.dispatchingPlaceCode = item.dispatchingPlaceCode
        this.afrForm.loadingPortCode = item.loadingPortCode
        this.afrForm.dischargingPortCode = item.dischargingPortCode
        this.afrForm.destinationPortCode = item.destinationPortCode
        this.afrForm.mark = item.mark
        this.afrForm.cargoEnglishName = item.cargoEnglishName
        this.afrForm.goodsType = item.goodsType
        this.afrForm.undgCode = item.undgCode
        this.afrForm.imdgClass = item.imdgClass
        this.afrForm.unNo = item.unNo
        this.afrForm.nvoccScac = item.nvoccScac
        this.afrForm.hazardousCode = item.hazardousCode
        this.afrForm.cargoDestinationCountry = item.cargoDestinationCountry
        this.afrForm.cargoDestinationCity = item.cargoDestinationCity
        this.afrForm.paperlessInBondParticipant = item.paperlessInBondParticipant
        this.afrForm.nationalityCodeofVessel = item.nationalityCodeofVessel
        this.afrForm.flashPointTemp = item.flashPointTemp
      }
      this.afrForm.countryOrigin = item.countryOrigin
      this.localData.nameOfCountry = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Country, 'code', this.afrForm.countryOrigin, 'name')
      this.afrForm.afrAddress[0].notifyLine1 = ''
      // 填充反恐地址信息
      this.syncAfrAddress(item.afrAddress[0])
      // 装箱信息
      const oldContainers = this.afrContainer.rowData
      if (importContainer) { // 导入装箱信息
        if (oldContainers && oldContainers.length > 0) {
          for (const row of oldContainers) {
            row['deleted'] = true
          }
        }
      }
      let packing = ''
      const containerInfo = item.ediContainer
      if (containerInfo && containerInfo.length > 0) {
        packing = containerInfo[0].unitType
        if (this.afrForm.hasOwnProperty('packing') && this.afrForm['packing'] !== packing && !StrUtils.isEmpty(packing)) {
          this.localData.importDifferentField['packing'] = true
        } else {
          delete this.localData.importDifferentField['packing']
        }
        if (!StrUtils.isEmpty(packing)) {
          const packingList = await getSpecificBasicData(TYPE_NAMES.basic_data_Packing)
          const pack = packingList.find(p => p.isoCode === packing || p.name === packing)
          this.afrForm.packing = (pack) ? pack.code : ''
        }
        for (const row of containerInfo) {
          row.containerUsageUuid = null
          row.cargoDocUuid = this.afrForm.uuid
          if (this.isJs) {
            row.packing = ColumnUtils.resolveSpecificField(this.localData.jsAfrPacking, 'name', item.packing, 'code')
            row.eqType = ColumnUtils.resolveSpecificField([...SystemConstants.JS_AFR_CONTAINER_TYPE], 'englishName', row.eqType, 'code')
            row.containerOwnershipCode = ColumnUtils.resolveSpecificField([...SystemConstants.JS_AFR_CONTAINER_OWNER], 'englishName', row.containerOwnershipCode, 'code')
          }
          oldContainers.push(row)
        }
      }
      if (this.isJs) {
        item.packing = ColumnUtils.resolveSpecificField(this.localData.jsAfrPacking, 'name', item.packing, 'code')
        if (this.afrForm.hasOwnProperty('packing') && this.afrForm['packing'] !== item.packing && !StrUtils.isEmpty(item.packing)) {
          this.localData.importDifferentField['packing'] = true
        } else {
          delete this.localData.importDifferentField['packing']
        }
        this.afrForm.packing = item.packing
      }
      this.afrContainer.rowData = oldContainers
      this.afrContainer.gridOptions.api.clearFocusedCell()
      this.afrContainer.gridOptions.api.refreshCells({ force: true })
      this.afrForm.frob = 'I'
      this.pm.loadAfr()
      this.pm.refAfrData()
      for (let afrCargoDocs of this.afrCargoDocs) {
        if (afrCargoDocs.uuid === this.afrForm.uuid) {
          afrCargoDocs = await new SeaCargoDoc(this.afrForm)
          break
        }
      }
    },
    async sendInThailand() {
      if (this.thailandCargoDocs.length === 0) {
        return
      }
      const loading = getLoading4Cxt(this)
      try {
        for (const doc of this.thailandCargoDocs) {
          await new SeaCargoDoc(doc).getAfrAddress()
          await new SeaCargoDoc(doc).getEdiContainer()
        }
        const { reminderContent, content } = await sendThailand(this.thailandCargoDocs, 'SE')
        this.thailandExportDialog.showReminder = !!reminderContent
        this.thailandExportDialog.reminderContent = reminderContent
        this.thailandExportDialog.content = content
        this.thailandExportDialog.visible = true
      } finally {
        loading.close()
      }
    },
    doExportThailand() {
      const data = this.thailandExportDialog.content
      const blob = new Blob([data], { type: 'text/plain' })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', this.job.jobNo + '.xml')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    // 分页查询
    toTradetechQueryByPage() {
      this.tradetechReceiptInfoDialog.filter.jobUuid = this.job.uuid
      this.tradetechReceiptInfoDialog.filter.jobNo = this.job.jobNo
      this.pm.tradetechQueryByPage(this.tradetechReceiptInfoDialog.filter)
    },
    // 获取Afr账号密码
    getAfrAccount() {
      if (!this.isJs) {
        return
      }
      getUserOfficeList().then((res) => {
        if (res.data.length > 0) {
          for (const office of res.data) {
            if (office.officeId === this.$store.getters.currentOfficeId) {
              this.afrForm.reporterID = office.jsAfrAccount
              this.afrForm.reporterPassword = office.jsAfrPassword
            }
          }
        }
      })
    },
    jsAfrDeleteClose() {
      this.jsAfrDeleteDialog.visible = false
      this.jsAfrDeleteDialog.deletionCode = '1'
    },
    // 劲升 导入模板
    importJsExcel(item) {
      if (this.tabAms) {
        this.importAMSExcel(item)
      } else if (this.tabAfr) {
        this.importAFRExcel(item)
      } else if (this.tabAci) {
        this.importACIExcel(item)
      }
    },
    // ACI 模板导入
    importACIExcel(item) {
      if (!this.curAms) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.oldAmsNo = this.curAms.hblNbr2
      const param = {
        file: item.file,
        jobUuid: this.job.uuid,
        importContainer: !this.isLcl,
        interfaceName: cache.config.get('AMSInterfaceName')
      }
      let isSend = false
      for (const row of this.ams2.rowData) {
        if (row.AMSSTATUS === 1 || row.EFSTATUS === 1 || row.ISF5STATUS === 1 || row.ISF10STATUS === 1) {
          isSend = true
          break
        }
      }
      if (isSend) {
        this.$confirm(this.$t('Message.ThePacketHasBeenSentAndWhetherToImportItAgain'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          importAciExcel(param).then(response => {
            this.importResult(response)
          })
        }).catch()
      } else {
        importAciExcel(param).then(response => {
          this.importResult(response)
        })
      }
    },
    // ENS 模板导入
    importEnsExcel(item) {
      if (!this.curAms) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.oldAmsNo = this.curAms.hblNbr2
      const param = {
        file: item.file,
        jobUuid: this.job.uuid,
        importContainer: !this.isLcl,
        interfaceName: cache.config.get('ENSSupplierConfiguration')
      }
      let isSend = false
      for (const row of this.ams2.rowData) {
        if (row.ENSSTATUS === 1) {
          isSend = true
          break
        }
      }
      if (isSend) {
        this.$confirm(this.$t('Message.ThePacketHasBeenSentAndWhetherToImportItAgain'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          importEnsExcel(param).then(response => {
            this.importResult(response)
          })
        }).catch()
      } else {
        importEnsExcel(param).then(response => {
          this.importResult(response)
        })
      }
    },
    getItemTitle(targetCode) {
      if (this.isChineseLanguage) {
        return ColumnUtils.afrLabelFunc(targetCode)
      }
      return targetCode
    },
    importIsfExcel(item) {
      if (!this.curAms) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.oldAmsNo = this.curAms.hblNbr2
      const param = {
        file: item.file,
        jobUuid: this.job.uuid,
        importContainer: !this.isLcl,
        interfaceName: cache.config.get('AMSInterfaceName')
      }
      let isSend = false
      for (const row of this.ams2.rowData) {
        if (row.AMSSTATUS === 1 || row.EFSTATUS === 1 || row.ISF5STATUS === 1 || row.ISF10STATUS === 1) {
          isSend = true
          break
        }
      }
      const file = item.file
      const fileName = file.name
      if (isSend) {
        this.$confirm(this.$t('Message.ThePacketHasBeenSentAndWhetherToImportItAgain'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          this.importIsfExcels(fileName, param)
        }).catch()
      } else {
        this.importIsfExcels(fileName, param)
      }
    },
    importIsfExcels(fileName, param) {
      if (fileName.includes('ISF5')) {
        importIsf5Excel(param)
          .then(response => {
            this.importResult(response)
          }).catch(error => {
            console.error('Error importing ISF5:', error)
          })
      } else if (fileName.includes('ISF10')) {
        importIsf10Excel(param)
          .then(response => {
            this.importResult(response)
          }).catch(error => {
            console.error('Error importing ISF10:', error)
          })
      } else {
        this.$message.error(this.$t('Message.ImportFailedFileNameNotMatch'))
      }
    },
    importEManifestExcel(item) {
      if (!this.curAms) {
        this.$message.info(this.$t('Message.SelectTheData'))
        return
      }
      this.oldAmsNo = this.curAms.hblNbr2
      const param = {
        file: item.file,
        jobUuid: this.job.uuid,
        importContainer: !this.isLcl,
        interfaceName: cache.config.get('AMSInterfaceName')
      }
      let isSend = false
      for (const row of this.ams2.rowData) {
        if (row.AMSSTATUS === 1 || row.EFSTATUS === 1 || row.ISF5STATUS === 1 || row.ISF10STATUS === 1) {
          isSend = true
          break
        }
      }
      if (isSend) {
        this.$confirm(this.$t('Message.ThePacketHasBeenSentAndWhetherToImportItAgain'), this.$t('SeaExport.tips'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          closeOnClickModal: false,
          type: 'info'
        }).then(() => {
          importEManifestExcel(param).then(response => {
            this.importResult(response)
          })
        }).catch()
      } else {
        importEManifestExcel(param).then(response => {
          console.log('importEManifestExcel', response)
          this.importResult(response)
        })
      }
    },
    commandHandle(command) {
      const folderName = 'booking'
      switch (command) {
        case 'ISF5':
          ExportUtils.downloadTemplateFile('ISF5 Template.xlsx', folderName)
          break
        case 'ISF10':
          ExportUtils.downloadTemplateFile('ISF10 Template.xlsx', folderName)
          break
      }
    },
    selectorDialogCallback(row) {
      const self = this
      this.globalVar.ediTemplate = row
      this.globalVar.popMultiSegNumRulesType = 1
      const param = {}
      param.ediType = self.globalVar.ediType
      param.templateId = self.globalVar.ediTemplate.uuid
      param.jobUuids = [this.job.uuid] // 这里传舱单的UUID
      param.editStatus = self.globalVar.editStatus
      param.ruleEDINos = []
      param.cargoDocUuid = this.activeTabName === 'afr' ? this.afrForm.uuid : this.form.uuid
      this.loading = getLoading()
      // 转移callback
      ediApi
        .getEDI(param)
        .then(result => self.commonCallback().onExportEDISuccess(result))
        .catch(message => self.commonCallback().onExportEDIFail(message))
        .finally(() => {
          self.loading.close()
        })
    },
    // EDI公共回调方法
    commonCallback() {
      const self = this
      // edi导出成功回调方法
      const onExportEDISuccess = async response => {
        if (!response || !response.data || JSON.stringify(response.data) === '{}') {
          self.$message.info(this.$t('SeaExport.NoImportEDI'))
          return
        }
        const data = response.data
        if (response.data.key) {
          this.ensKey = response.data.key
          delete data.key
        }
        self.globalVar.ediTemplate.sendType = this.getAmsEdiSendType(self.globalVar.ediType, self.globalVar.editStatus)
        self.messagePreviewDialog.params = {
          job: self.job,
          title: this.getAmsEdiTitle(self.globalVar.ediType),
          ediType: self.globalVar.ediType,
          index: self.globalVar.editStatus,
          ediCollection: data,
          ediTemplate: self.globalVar.ediTemplate,
          hblNbr2: this.form.hblNbr2,
          ensKey: this.ensKey
        }
        self.messagePreviewDialog.visible = true
      }
      // edi导出失败回调方法
      const onExportEDIFail = dataMsg => {
        if (dataMsg instanceof Error) {
          return
        }
        const errorMsgStr = dataMsg ? dataMsg.replaceAll(';', '<br/>') : null
        self.$message.error({
          dangerouslyUseHTMLString: true,
          message: errorMsgStr
        })
      }
      return { onExportEDISuccess, onExportEDIFail }
    },
    // 获取反恐舱单发送EDI title
    getAmsEdiSendType(ediType, editStatus) {
      switch (ediType) {
        case EdiType.ENS.code:
          return editStatus === SAVE.code ? 'SaveENS' : 'SendENS'
        case EdiType.AFR_EDI_TYPE.code:
          return 'SendAFR'
      }
      return ''
    },
    // 获取反恐舱单发送EDI title
    getAmsEdiTitle(ediType) {
      switch (ediType) {
        case EdiType.ENS.code:
          return 'ENS'
        case EdiType.AFR_EDI_TYPE.code:
          return 'AFR'
      }
      return ''
    },
    // ens 亿通、一飞回执code转换
    ensReceipt(code) {
      if (this.ensIsYitong) {
        if (code === 'T') {
          return this.getItemTitle('Send Success')
        } else if (code === 'F') {
          return this.getItemTitle('Rejected')
        }
      }
      if (this.ensIsEFreight) {
        if (code === 'A') {
          return this.getItemTitle('Send Success')
        } else if (code === 'R') {
          return this.getItemTitle('Rejected')
        } else if (code === 'SN') {
          return this.getItemTitle('Status Notification')
        }
      }
      return code
    },
    // 显示删除原因弹框
    showDeleteReasonDialog() {
      this.deleteReasonDialog.visible = true
      this.deleteReasonDialog.reasonCode = 'Misregistration' // 默认选中"登记错误 - 登记错误"
      this.deleteReasonDialog.reasonDescription = ''
      // 清除表单验证
      this.$nextTick(() => {
        if (this.$refs.deleteReasonForm) {
          this.$refs.deleteReasonForm.clearValidate()
        }
      })
    },
    // 删除原因改变事件
    onDeleteReasonChange(value) {
      // 当不是"其他"时，清空原因说明的验证
      if (value !== 'Other') {
        this.$nextTick(() => {
          if (this.$refs.deleteReasonForm) {
            this.$refs.deleteReasonForm.clearValidate(['reasonDescription'])
          }
        })
      }
    },
    // 确定删除
    confirmDeleteReason() {
      this.$refs.deleteReasonForm.validate((valid) => {
        if (valid) {
          this.pm.linkSendAfr(2, this.deleteReasonDialog.reasonCode, this.deleteReasonDialog.reasonDescription)
          // 关闭弹框
          this.deleteReasonDialog.visible = false
        }
      })
    },
    // 取消删除
    cancelDeleteReason() {
      this.deleteReasonDialog.visible = false
      this.deleteReasonDialog.reasonCode = 'Misregistration'
      this.deleteReasonDialog.reasonDescription = ''
    }
  }
}
</script>

<style lang="scss">
  .el-message-box__message{
    max-height: 400px;
    p{
      max-height: 380px;
      overflow: auto;
    }
  }
  .thailand-export {
    .cargo-rich-textarea.quill-editor .ql-container .ql-editor p {
      line-height: 22px;
    }
  }
</style>
